import * as z from 'zod/mini';
import { SCALAR_MEASUREMENTS } from './scalarMeasurements.js';
export const ScalarMeasurementKind = z.enum(Object.keys(SCALAR_MEASUREMENTS));
//# sourceMappingURL=ScalarMeasurementKind.js.map